import styled, { css } from 'styled-components'
import { flow } from '@styles/utils/functions.style'
import { font } from '@styles/vars/font.style'
import { TextBody } from '@styles/vars/textStyles.style'
import { ButtonMain } from '@components/Button/index.style'
import { roundedCorners } from '@utils'
import { colors } from '@styles/vars/colors.style'
import { clamp } from '@styles/utils/conversion.style'

export const RichTextDefaults = css`
  strong:empty {
    display: none;
  }
  a {
    text-decoration: underline;
    display: inline-block;
  }

  .gatsby-image-wrapper {
    ${roundedCorners}
  }

  ${ButtonMain} {
    text-decoration: none;
  }

  * + ${ButtonMain} {
    margin-top: 4rem;
  }
  sub {
    font-size: 60%;
    vertical-align: inherit;
  }
  sup {
    font-size: 60%;
    vertical-align: super;
  }
  p:empty {
    display: none;
  }
`

export const ButtonContainer = styled.div`
`

export const RichTextMain = styled.div`
  ${RichTextDefaults}
  ${flow(2)}
`

export const UnorderedList = styled.ul`
  list-style: none;
`

export const OrderedList = styled.ol`
  counter-reset: ol;
  list-style: none;
`

export const ListItem = styled.li`
  ${TextBody} {
    position: relative;

    &:before {
      counter-increment: ol;
      position: absolute;
      left: 0;
      display: block;
      overflow: hidden;
    }

    ul & {
      padding-left: 0.75em;

      &:before {
        content: '';
        top: 0.6em;
        width: 0.7rem;
        height: 0.7rem;
        border-radius: 50%;
        background-color: currentColor;
      }
    }

    ol & {
      padding-left: 1.1em;

      &:before {
        content: counter(ol) '.';
        top: 0;
        font-weight: ${font.sans.weight.regular};
      }
    }
  }

  & + & {
    margin-top: 0.5em;
  }
`

const tableStyles = css`
  border-collapse: collapse;
  border: 1px solid ${colors.charcoal};
`

export const cellStyles = css`
  ${clamp('padding', 10, 20)}
`

export const TableWrapper = styled.div`
  overflow-x: auto;
`

export const Table = styled.table`
  ${tableStyles}
`

export const TableRow = styled.tr`
  vertical-align: top;
`

export const TableCell = styled.td`
  ${cellStyles}
  ${tableStyles}
`

export const TableHead = styled.th`
  ${cellStyles}
  vertical-align: middle;
  text-align: left;
  background-color: ${colors.charcoal};
  color: ${colors.white};
  ${tableStyles}
`
